import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Grid from '@mui/material/Grid';
import RadioGroup from '@mui/material/RadioGroup';
import { type ReactNode, useEffect, useState } from 'react';
import { Radio } from '../Radio/Radio';

type ChildProps = {
  label: string;
  helperText: string;
  child: ReactNode;
  dataTest: string;
};

type RadioComponentSwitchProps = {
  children: ChildProps[];
  onSwitchChange: (selected: number) => void;
  divider?: boolean;
  initialSelectedOption?: number;
  selectedOption?: number;
  overrideXsValue?: number;
};

export function RadioComponentSwitch({
  children,
  divider,
  selectedOption,
  initialSelectedOption,
  onSwitchChange,
  overrideXsValue,
}: RadioComponentSwitchProps) {
  const [selected, setSelected] = useState(initialSelectedOption ?? '');

  useEffect(() => {
    if (selectedOption !== undefined) {
      setSelected(selectedOption ?? '');
    }
  }, [selectedOption]);

  return (
    <Box>
      <Grid container>
        <RadioGroup
          row
          value={selected}
          onChange={event => {
            if (selectedOption === undefined) {
              setSelected(+event.target.value);
            }
            onSwitchChange(+event.target.value);
          }}
          sx={{ flexGrow: 1 }}
        >
          {children.map(({ label, helperText, dataTest }, index) => (
            <Grid size={overrideXsValue === 0 ? undefined : (overrideXsValue ?? 4)} key={label} data-test={dataTest}>
              <FormControlLabel value={index} control={<Radio />} label={label} data-test="label" />
              <FormHelperText sx={{ marginBottom: 3, marginLeft: 0, maxWidth: '95%' }} data-test={'helper-text'}>
                {helperText}
              </FormHelperText>
            </Grid>
          ))}
        </RadioGroup>
      </Grid>

      {divider && <Divider sx={{ marginBottom: 3 }} />}
      {typeof selected === 'number' && children[selected]?.child}
    </Box>
  );
}
